import React from 'react';
import intl from 'components/i18n/ReactIntlWrapper';
import { useNewInvoice } from './newInvoiceProvider';
import { Table, TableHead, TableBody, TableRow, TableCell, Box, Stack, Typography } from '@mui/material';
import '../../scss/NewInvoice.scss';

const NewInvoiceItemTableRowView = ({ item, index }) => {
    const formatAmount = (amount) => {
        return amount ? parseFloat(amount).toFixed(2) : '0.00';
    };

    return (
        <>
            <TableRow className={"no-border"} sx={{cursor: "default"}}>
                <TableCell>
                    <input
                        id="description"
                        placeholder={intl.get('newInvoice.desctiption.placeholder')}
                        value={item?.description || ''}
                        disabled={true}
                        style={{width: '100%', padding: '8px'}}
                    />
                </TableCell>
                <TableCell>
                    <input
                        id="quantity"
                        type="number"
                        placeholder="0"
                        value={item?.quantity || ''}
                        disabled={true}
                        style={{width: '100%', padding: '8px'}}
                    />
                </TableCell>
                <TableCell>
                    <input
                        id="rate"
                        type="number"
                        placeholder="0"
                        value={formatAmount(item?.amount / item?.quantity)}
                        disabled={true}
                        style={{width: '100%', padding: '8px'}}
                    />
                </TableCell>
                <TableCell>
                    <input
                        id="amount"
                        type="number"
                        placeholder="0"
                        value={formatAmount(item?.amount)}
                        disabled={true}
                        style={{width: '100%', padding: '8px'}}
                    />
                </TableCell>
            </TableRow>
            {item.invoiceItemTaxes && item.invoiceItemTaxes.length > 0 && (
                <TableRow className={"no-border"} sx={{cursor: "default"}}>
                    <TableCell>
                    </TableCell>
                    <TableCell colSpan={2}>
                        <Stack gap={2}>
                            {item.invoiceItemTaxes?.map((tax, taxIndex) => (
                                <Box key={taxIndex} sx={{display: "flex", alignItems: "center"}}>
                                    <input
                                        id='tax'
                                        value={(() => {
                                            const name = tax.taxRateEntity?.name || tax.name || '';
                                            if (!name) return '';
                                            const rate = tax.taxRate || 0;
                                            const amount = tax.taxAmount || 0;
                                            return `${name} [${rate > 0 ? `${rate}%` : `$${amount}`}]`;
                                        })()}
                                        disabled={true}
                                        placeholder="Taxes"
                                        style={{width: '100%', padding: '8px'}}
                                    />
                                </Box>
                            ))}
                        </Stack>
                    </TableCell>
                    <TableCell>
                    </TableCell>
                </TableRow>
            )}
            <TableRow className={"no-border"} sx={{cursor: "default"}}>
                <TableCell colSpan={4} style={{padding: "0px"}}>
                    <hr/>
                </TableCell>
            </TableRow>
        </>
    );
};

const NewInvoiceItemTableView = () => {
    const { input } = useNewInvoice();

    return (
        <div className="table-responsive my-2">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell width={"40%"} className='black-header' sx={{cursor: "default"}}>{intl.get('newInvoice.desctiption')}</TableCell>
                        <TableCell className='black-header' sx={{cursor: "default"}}>{intl.get('newInvoice.qty')}</TableCell>
                        <TableCell className='black-header' sx={{cursor: "default"}}>{intl.get('newInvoice.rate')}</TableCell>
                        <TableCell width={"25%"} className='black-header' sx={{cursor: "default"}}>{intl.get('newInvoice.amount')}</TableCell>
                    </TableRow>
                </TableHead>
                {input.invoiceItems && input.invoiceItems.length > 0 && (
                    <TableBody>
                        {input.invoiceItems.map((item, index) => (
                            <NewInvoiceItemTableRowView
                                key={item.id || index}
                                item={item}
                                index={index}
                            />
                        ))}
                    </TableBody>
                )}
            </Table>
            {(!input.invoiceItems || input.invoiceItems.length === 0) && (
                <Box p={3} textAlign="center">
                    <Typography variant="body2" color="textSecondary">
                        No items to display
                    </Typography>
                </Box>
            )}
        </div>
    );
};

export default NewInvoiceItemTableView;
